<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">



        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <app-sub-header title="Bulletins"></app-sub-header>
                        <div class="margin-b" style="text-align: end;">
                            <button routerLink='create-bulletine' class="btn  main-backgroundcolor color">
                                Add Bulletin</button>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-md-12">
                        <div *ngIf="loading">
                            <div class="card" *ngFor="let props of objArr">
                                <!-- <div class="card-header">
                            Featured
                        </div> -->
                                <div class="card-body">
                                    <div class="display">
                                        <div class="image-wrapper">
                                            <img [src]="" (error)="getErrorImage($event)">
                                        </div>

                                        <div class="margin-l">
                                            <h5 class="card-title">{{props.name}}</h5>
                                            <p *ngIf="props.link == ''" class="card-text"><a
                                                    [href]="props.file" target="_blank">{{props.file}}</a>
                                            </p>

                                            <p *ngIf="props.link != ''" class="card-text"><a
                                                    [attr.href]="checkUrl(props.link)"
                                                    target="_blank">{{props.link}}</a>
                                            </p>

                                            <p class="card-text">Uploaded by {{props.createdBy.name}} on
                                                {{props.createdAt |
                                                date : 'medium'}}
                                            </p>
                                            <div class="display">
                                                <a class="btn color main-backgroundcolor" (click)="navigate(props._id)">Update</a>
                                                <a class="btn btn-danger margin-l"
                                                    (click)="deleteBulletin(props._id)">Delete</a>

                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div *ngIf="!loading">
                            <div *ngFor="let props of arr">
                                <app-card-skelton></app-card-skelton>
                            </div>
                        </div>
                        <app-no-results-found *ngIf="objArr.length == 0 && loading" title='Bulletin'>
                        </app-no-results-found>

                    </div>
                </div>













                <!-- 
                <div *ngIf="loading" class="col-md-12" style="text-align: center;">
                    <pagination-controls class="col s12 col-md-offset-3 my-pagination" *ngIf="objArr?.length > 0 "
                        (pageChange)="page = getAlerts($event)" directionLinks="true" autoHide="false" responsive="true"
                        previousLabel="Previous" nextLabel="Next" screenReaderPaginationLabel="Pagination"
                        screenReaderPageLabel="page" screenReaderCurrentLabel="You're on page">
                    </pagination-controls>
                </div> -->

            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>